import { satelliteTracker } from '../../services/tracking/satellite-tracking-service';
import { getLocalStorage, setLocalStorage } from '../../utils/local-storage';

let flag = true;

const initDatalayerElement = (parent = document) => {
  Array.from(parent.querySelectorAll('[data-zoneid]')).forEach((ln) => {
    ln.addEventListener('click', () => {
      setLocalStorage('zoneid', ln.dataset.zoneid);
    });
  });

  Array.from(parent.querySelectorAll('[data-intcmp]')).forEach((ln) => {
    ln.addEventListener('click', () => {
      setLocalStorage('intcmp', ln.dataset.intcmp);
    });
  });

  Array.from(parent.querySelectorAll('[data-zoneid-qp]')).forEach((ln) => {
    ln.addEventListener('click', () => {
      const url = new URL(ln.href);
      url.searchParams.set('zoneid', ln.dataset.zoneidQp);
      ln.href = url;
    });
  });

  Array.from(parent.querySelectorAll('[data-intcmp-qp]')).forEach((ln) => {
    ln.addEventListener('click', () => {
      const url = new URL(ln.href);
      url.searchParams.set('intcmp', ln.dataset.intcmpQp);
      ln.href = url;
    });
  });
};

const initDtmAnalitycs = () => {
  const dtmSrc = document.querySelector('#dtm_script') ? document.querySelector('#dtm_script') : false;
  if (dtmSrc && flag) {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = dtmSrc.dataset.src;
    document.querySelector('head').appendChild(s);
    flag = false;
  }
};

const addDatalayerAttrs = () => {
  const datalayer = window.digitalData;
  if (datalayer) {
    const sessionZoneId = getLocalStorage('zoneid') ? getLocalStorage('zoneid') : '';
    const sessionIntCmp = getLocalStorage('intcmp') ? getLocalStorage('intcmp') : '';

    // Setting property zoneid/intcmp
    datalayer.page.pageInfo.zoneid = `${sessionZoneId}`;
    datalayer.page.pageInfo.intcmp = `${sessionIntCmp}`;

    // clean session storage after set in datalayer
    localStorage.removeItem('zoneid');
    localStorage.removeItem('intcmp');

    // script for video count
    const videoCount = document.querySelectorAll('.j-player');

    videoCount.forEach((element) => {
      if (element.style.display !== 'none') {
        window.digitalData.page.pageInfo.totaleplayer = videoCount.length;
      }
    });

    if (videoCount.length === 0) {
      window.digitalData.page.pageInfo.totaleplayer = 0;
    }

    // script for days count
    const pubbl =
      window.digitalData.page.pageInfo.primapubblicazione !== undefined
        ? window.digitalData.page.pageInfo.primapubblicazione.split('/')
        : [];

    if (pubbl.length === 3) {
      const datePubbl = new Date(pubbl[2], pubbl[1] - 1, pubbl[0]);
      const dateNow = new Date();
      const diff = dateNow.getTime() - datePubbl.getTime();
      let daydiff = Math.round(diff / (1000 * 60 * 60 * 24) - 1); // -1 to exclude the publication day
      // contatoregiorni with negative values fallbacks in 0
      if (daydiff < 0) {
        daydiff = 0;
      }
      // Setting property contatoregiorni
      window.digitalData.page.pageInfo.contatoregiorni = daydiff.toString();
    }
  }

  // call dtm lib

  console.info('init DTM script');
  if (document.readyState !== 'loading') {
    initDtmAnalitycs();
  } else {
    document.addEventListener('readystatechange', (event) => {
      if (event.target.readyState === 'complete') {
        initDtmAnalitycs();
      }
    });
  }

  // call satellite script after is defined
  const satelliterequestIdleCallback = () => {
    if (satelliteTracker.getSatellite()) {
      satelliteTracker.getSatellite().pageBottom();
    } else {
      window.requestIdleCallback(satelliterequestIdleCallback, { timeout: 500 });
    }
  };

  const satelliteSetInterval = () => {
    if (satelliteTracker.getSatellite()) {
      satelliteTracker.getSatellite().pageBottom();
    } else {
      window.satelliteInterval = setTimeout(satelliteSetInterval, 500);
    }
  };

  if (window.requestIdleCallback) {
    satelliterequestIdleCallback();
  } else {
    satelliteSetInterval();
  }
};

const initDataLayerAttributes = () => {
  addDatalayerAttrs();
};

export { initDataLayerAttributes, initDatalayerElement, addDatalayerAttrs };
